import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseServicesSearch } from "@/features/catalog";
import { ServicesPage } from "@/features/catalog/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/catalog/services/")({
  validateSearch: strictSearch(parseServicesSearch),
  component: Services,
});

function Services() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <ServicesPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(serviceId) =>
        router.buildLocation({ to: "/catalog/services/$serviceId", params: { serviceId } }).href
      }
      onOpen={(serviceId) =>
        void router.navigate({ to: "/catalog/services/$serviceId", params: { serviceId } })
      }
    />
  );
}
